import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { clienteNome, formatDate, Modal, ConfirmDialog, LoadingSpinner } from '../components/shared';

const tk = () => 'Bearer ' + (localStorage.getItem('sp_token') || '');
const apiFetch = (url, opts={}) => fetch(url, {
  headers: { Authorization: tk(), 'Content-Type':'application/json', ...opts.headers }, ...opts
});

// ─── COSTANTI ─────────────────────────────────────────────────────────────────
const CATEGORIE = [
  { key:'730',         label:'730',                      icon:'📄', cat:'PF',  desc:'Dipendenti e pensionati' },
  { key:'UNICO_PF',    label:'Unico PF',                 icon:'📋', cat:'PF',  desc:'Autonomi e professionisti' },
  { key:'IMU',         label:'IMU',                      icon:'🏠', cat:'PF',  desc:'Imposta municipale unica' },
  { key:'ISEE',        label:'ISEE/DSU',                 icon:'📊', cat:'PF',  desc:'Indicatore situazione economica' },
  { key:'SUCCESSIONE', label:'Successione',              icon:'⚖️', cat:'PF',  desc:'Dichiarazione di successione' },
  { key:'ALTRO_PF',    label:'Altro PF',                 icon:'📎', cat:'PF',  desc:'Altre dichiarazioni persone fisiche' },
  { key:'UNICO_SC',    label:'Unico SC',                 icon:'🏢', cat:'SOC', desc:'Società di capitali' },
  { key:'UNICO_SP',    label:'Unico SP',                 icon:'🏛️', cat:'SOC', desc:'Società di persone' },
  { key:'IRAP',        label:'IRAP',                     icon:'💰', cat:'SOC', desc:'Imposta regionale attività produttive' },
  { key:'770',         label:'770',                      icon:'👥', cat:'SOC', desc:'Sostituto d\'imposta' },
  { key:'IVA_ANNUALE', label:'IVA Annuale',              icon:'📑', cat:'SOC', desc:'Dichiarazione IVA annuale' },
  { key:'ALTRO_SOC',   label:'Altro Società',            icon:'📎', cat:'SOC', desc:'Altre dichiarazioni societarie' },
];

const STATI = [
  { key:'DA_FARE',        label:'Da fare',        color:'var(--text-faint)' },
  { key:'IN_LAVORAZIONE', label:'In lavorazione', color:'var(--c-amber)'   },
  { key:'COMPLETATA',     label:'Completata',     color:'var(--c-green)'   },
  { key:'INVIATA',        label:'Inviata',        color:'var(--accent)'    },
];

const TIPI_ALLEGATO = [
  { key:'documenti',     label:'📁 Documenti cliente' },
  { key:'dichiarazione', label:'📄 Dichiarazione' },
  { key:'pagamenti',     label:'💳 Prospetto pagamenti' },
  { key:'altro',         label:'📎 Altro' },
];

function statoInfo(s) { return STATI.find(x=>x.key===s) || { label:s, color:'var(--text-faint)' }; }
function catInfo(k) { return CATEGORIE.find(c=>c.key===k) || { label:k, icon:'📄', cat:'PF' }; }

// ─── PAGINA HOME: selezione categoria ────────────────────────────────────────
function HomeDichiarazioni({ onSelect }) {
  const [counts, setCounts] = useState({});

  useEffect(()=>{
    apiFetch('/api/dichiarazioni/counts')
      .then(r=>r.json()).then(j=>{ if(j.success) setCounts(j.data||{}); });
  },[]);

  const pf  = CATEGORIE.filter(c=>c.cat==='PF');
  const soc = CATEGORIE.filter(c=>c.cat==='SOC');

  const Card = ({cat}) => {
    const tot = counts[cat.key] || 0;
    const inviate = counts[cat.key+'_INVIATA'] || 0;
    return (
      <div onClick={()=>onSelect(cat.key)} style={{
        background:'var(--surface)', border:'2px solid var(--border)',
        borderRadius:'var(--radius)', padding:'16px 18px', cursor:'pointer',
        transition:'border 0.15s, box-shadow 0.15s',
        display:'flex', alignItems:'center', gap:14,
      }}
      onMouseEnter={e=>{e.currentTarget.style.border='2px solid var(--accent)'; e.currentTarget.style.boxShadow='0 2px 12px rgba(0,0,0,0.07)';}}
      onMouseLeave={e=>{e.currentTarget.style.border='2px solid var(--border)'; e.currentTarget.style.boxShadow='none';}}>
        <div style={{ fontSize:28 }}>{cat.icon}</div>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:14 }}>{cat.label}</div>
          <div style={{ fontSize:11, color:'var(--text-faint)', marginTop:2 }}>{cat.desc}</div>
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:20, fontWeight:800, color: tot>0?'var(--accent)':'var(--border-strong)' }}>{tot}</div>
          {inviate>0 && <div style={{ fontSize:10, color:'var(--c-green)', fontWeight:600 }}>✓ {inviate} inv.</div>}
        </div>
      </div>
    );
  };

  return (
    <div className="page-content">
      <div style={{ fontSize:18, fontWeight:700, marginBottom:20 }}>📋 Dichiarativi</div>
      <div style={{ marginBottom:8, fontSize:11, fontWeight:700, color:'var(--text-faint)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Persone Fisiche</div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:20 }}>
        {pf.map(c=><Card key={c.key} cat={c} />)}
      </div>
      <div style={{ marginBottom:8, fontSize:11, fontWeight:700, color:'var(--text-faint)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Società</div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10 }}>
        {soc.map(c=><Card key={c.key} cat={c} />)}
      </div>
    </div>
  );
}

// ─── FORM NUOVA/MODIFICA ──────────────────────────────────────────────────────
function DichiarazioneForm({ initial={}, clientiList, tipoDich, onSave, onClose, loading }) {
  const [d, setD] = useState({
    id_cliente:'', anno_imposta:new Date().getFullYear()-1,
    tipo_dichiarazione:tipoDich, stato:'DA_FARE',
    data_invio:'', protocollo:'', note:'',
    ...initial, id_cliente:initial.id_cliente||'',
  });
  const set = (k,v) => setD(p=>({...p,[k]:v}));

  return (
    <form onSubmit={e=>{e.preventDefault();onSave(d);}}>
      <div className="form-grid">
        <div className="form-group form-full">
          <label className="form-label">Cliente *</label>
          <select className="form-control" value={d.id_cliente} onChange={e=>set('id_cliente',e.target.value)} required>
            <option value="">— Seleziona —</option>
            {clientiList.map(c=><option key={c.id} value={c.id}>{clienteNome(c)}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Anno imposta *</label>
          <input className="form-control" type="number" value={d.anno_imposta}
            onChange={e=>set('anno_imposta',e.target.value)} required min={2000} max={2099} />
        </div>
        <div className="form-group">
          <label className="form-label">Stato</label>
          <select className="form-control" value={d.stato} onChange={e=>set('stato',e.target.value)}>
            {STATI.map(s=><option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Data invio</label>
          <input className="form-control" type="date" value={d.data_invio||''} onChange={e=>set('data_invio',e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Protocollo</label>
          <input className="form-control" value={d.protocollo||''} onChange={e=>set('protocollo',e.target.value)} />
        </div>
        <div className="form-group form-full">
          <label className="form-label">Note</label>
          <textarea className="form-control" rows={2} value={d.note||''} onChange={e=>set('note',e.target.value)} />
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn" onClick={onClose}>Annulla</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'⏳':'Salva'}</button>
      </div>
    </form>
  );
}

// ─── IMPORT EXCEL MODALE ──────────────────────────────────────────────────────
function ImportModal({ tipoDich, onClose, onDone, addToast }) {
  const [step, setStep] = useState('upload'); // upload | preview | done
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);
  const cat = catInfo(tipoDich);

  const handleFile = async (file) => {
    setLoading(true);
    const fd = new FormData(); fd.append('file', file); fd.append('tipo', tipoDich);
    const res = await fetch('/api/dichiarazioni/preview-import', { method:'POST', headers:{Authorization:tk()}, body:fd });
    const j = await res.json();
    if (j.success) { setRows(j.data); setStep('preview'); }
    else addToast(j.error,'error');
    setLoading(false);
  };

  const handleImport = async () => {
    setLoading(true);
    const res = await apiFetch('/api/dichiarazioni/conferma-import', {
      method:'POST', body: JSON.stringify({ righe: rows.filter(r=>r.action!=='skip'), tipo: tipoDich })
    });
    const j = await res.json();
    if (j.success) {
      addToast(`${j.data.importati} importate, ${j.data.nuovi_clienti} nuovi clienti creati`,'success');
      onDone();
    } else addToast(j.error,'error');
    setLoading(false);
  };

  return (
    <div>
      {step==='upload' && (
        <div style={{ textAlign:'center', padding:'20px 0' }}>
          <div style={{ fontSize:36, marginBottom:12 }}>{cat.icon}</div>
          <div style={{ fontWeight:600, marginBottom:6 }}>Importa lista {cat.label}</div>
          <div style={{ fontSize:12, color:'var(--text-faint)', marginBottom:20, lineHeight:1.6 }}>
            Il file Excel deve contenere almeno una colonna con CF o P.IVA del cliente.<br/>
            Le colonne opzionali sono: Anno, Stato, Protocollo, Note.
          </div>
          <div style={{ border:'2px dashed var(--border-strong)', borderRadius:'var(--radius)', padding:24,
            cursor:'pointer', background:'var(--bg)' }} onClick={()=>fileRef.current?.click()}>
            <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv" style={{display:'none'}}
              onChange={e=>{ if(e.target.files[0]) handleFile(e.target.files[0]); }} />
            {loading ? '⏳ Analisi in corso…' : '📂 Clicca o trascina il file Excel/CSV'}
          </div>
        </div>
      )}

      {step==='preview' && (
        <div>
          <div style={{ fontSize:13, marginBottom:12, color:'var(--text-muted)' }}>
            Trovate <strong>{rows.length}</strong> righe — verifica e conferma:
          </div>
          <div style={{ maxHeight:360, overflowY:'auto', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)' }}>
            {/* Header */}
            <div style={{ display:'grid', gridTemplateColumns:'28px 1fr 80px 100px 80px',
              gap:8, padding:'6px 12px', background:'var(--bg)', fontSize:10.5,
              fontWeight:700, color:'var(--text-faint)', textTransform:'uppercase', borderBottom:'2px solid var(--border)' }}>
              <div></div><div>Cliente</div><div>Anno</div><div>Stato</div><div>Azione</div>
            </div>
            {rows.map((r,i)=>(
              <div key={i} style={{ display:'grid', gridTemplateColumns:'28px 1fr 80px 100px 80px',
                gap:8, padding:'7px 12px', borderBottom:'1px solid var(--border)',
                fontSize:12, alignItems:'center',
                background: r.action==='new_client'?'#FFFBEB': r.action==='not_found'?'#FEF2F2':'transparent' }}>
                <input type="checkbox" checked={r.action!=='skip'}
                  onChange={()=>setRows(prev=>prev.map((x,j)=>j===i?{...x,action:x.action==='skip'?(x._origAction||'import'):'skip'}:x))} />
                <div>
                  <div style={{ fontWeight:500 }}>{r.cliente_nome || r.cf || r.piva || '—'}</div>
                  {r.action==='not_found' && <div style={{ fontSize:10, color:'var(--c-red)' }}>⚠ Non trovato in anagrafica — verrà creato</div>}
                  {r.action==='new_client' && <div style={{ fontSize:10, color:'var(--c-amber)' }}>🆕 Nuovo cliente da creare</div>}
                </div>
                <div>{r.anno_imposta}</div>
                <div>{r.stato||'DA_FARE'}</div>
                <div style={{ fontSize:10, color: r.action==='skip'?'var(--text-faint)':'var(--c-green)' }}>
                  {r.action==='skip'?'Salta':'Importa'}
                </div>
              </div>
            ))}
          </div>
          <div className="modal-footer" style={{ marginTop:12 }}>
            <button className="btn" onClick={()=>setStep('upload')}>← Indietro</button>
            <button className="btn btn-primary" onClick={handleImport} disabled={loading}>
              {loading?'⏳':'✓ Importa '+rows.filter(r=>r.action!=='skip').length+' righe'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── DETTAGLIO DICHIARAZIONE ──────────────────────────────────────────────────
function DettaglioDichiarazione({ id, onBack, addToast }) {
  const [dich, setDich] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tipoAll, setTipoAll] = useState('documenti');
  const fileRef = useRef(null);

  const load = useCallback(()=>{
    setLoading(true);
    apiFetch(`/api/dichiarazioni/${id}`).then(r=>r.json())
      .then(j=>{ if(j.success) setDich(j.data); }).finally(()=>setLoading(false));
  },[id]);
  useEffect(()=>{ load(); },[load]);

  if (loading) return <div className="page-content"><LoadingSpinner /></div>;
  if (!dich) return <div className="page-content">Non trovata</div>;

  const cat = catInfo(dich.tipo_dichiarazione);
  const si = statoInfo(dich.stato);
  const allegatiPerTipo = TIPI_ALLEGATO.reduce((acc,t)=>{ acc[t.key]=(dich.allegati||[]).filter(a=>a.tipo===t.key); return acc; },{});

  const fileUrl = (fn) => fn && !fn.includes('.') && fn.length>20
    ? 'https://drive.google.com/file/d/'+fn.split('::')[0]+'/view'
    : '/uploads/'+fn;
  const nomeFile = (a) => a.nome || (a.filename||'').split('/').pop().replace(/^\d+_/,'');

  const uploadFiles = async (files) => {
    for (const file of Array.from(files)) {
      const fd = new FormData(); fd.append('file',file); fd.append('tipo',tipoAll);
      await fetch(`/api/dichiarazioni/${id}/allegati`,{method:'POST',headers:{Authorization:tk()},body:fd});
    }
    addToast('Allegati caricati','success'); load();
  };

  const delAllegato = async (aid) => {
    if(!window.confirm('Eliminare?')) return;
    await apiFetch(`/api/dichiarazioni/allegati/${aid}`,{method:'DELETE'}); load();
  };

  const salva = async () => {
    setSaving(true);
    try {
      const res = await apiFetch(`/api/dichiarazioni/${id}`,{method:'PUT',body:JSON.stringify(dich)});
      const j = await res.json();
      if(!j.success) throw new Error(j.error);
      addToast('Salvata','success');
    } catch(e){ addToast(e.message,'error'); }
    finally { setSaving(false); }
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:16}}>
        <button className="btn btn-sm" onClick={onBack}>← {cat.label}</button>
        <div style={{flex:1}}>
          <div style={{fontSize:16,fontWeight:700}}>{clienteNome(dich)}</div>
          <div style={{fontSize:12,color:'var(--text-faint)'}}>{cat.icon} {cat.label} · Anno {dich.anno_imposta}</div>
        </div>
        <span style={{padding:'3px 10px',borderRadius:10,fontSize:12,fontWeight:600,background:si.color+'22',color:si.color}}>{si.label}</span>
        <button className="btn btn-primary btn-sm" onClick={salva} disabled={saving}>{saving?'⏳':'💾 Salva'}</button>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 300px',gap:16}}>
        <div>
          <div className="card" style={{marginBottom:14}}>
            <div className="card-header"><span className="card-title">Dati</span></div>
            <div className="card-body">
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <label className="form-label">Stato</label>
                  <select className="form-control" value={dich.stato} onChange={e=>setDich(p=>({...p,stato:e.target.value}))}>
                    {STATI.map(s=><option key={s.key} value={s.key}>{s.label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="form-label">Anno imposta</label>
                  <input className="form-control" type="number" value={dich.anno_imposta}
                    onChange={e=>setDich(p=>({...p,anno_imposta:e.target.value}))} />
                </div>
                <div>
                  <label className="form-label">Data invio</label>
                  <input className="form-control" type="date" value={dich.data_invio||''} onChange={e=>setDich(p=>({...p,data_invio:e.target.value}))} />
                </div>
                <div>
                  <label className="form-label">Protocollo</label>
                  <input className="form-control" value={dich.protocollo||''} onChange={e=>setDich(p=>({...p,protocollo:e.target.value}))} />
                </div>
                <div style={{gridColumn:'1/-1'}}>
                  <label className="form-label">Note</label>
                  <textarea className="form-control" rows={3} value={dich.note||''} onChange={e=>setDich(p=>({...p,note:e.target.value}))} />
                </div>
              </div>
            </div>
          </div>

          {TIPI_ALLEGATO.map(t=>(
            <div key={t.key} className="card" style={{marginBottom:10}}>
              <div className="card-header" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <span className="card-title">{t.label} ({allegatiPerTipo[t.key]?.length||0})</span>
                <button className="btn btn-sm btn-primary" onClick={()=>{setTipoAll(t.key);fileRef.current?.click();}}>+ Allega</button>
              </div>
              {allegatiPerTipo[t.key]?.length>0 && (
                <div className="card-body" style={{padding:'8px 14px'}}>
                  {allegatiPerTipo[t.key].map(a=>(
                    <div key={a.id} style={{display:'flex',alignItems:'center',gap:8,padding:'5px 0',borderBottom:'1px solid var(--border)'}}>
                      <a href={fileUrl(a.filename)} target="_blank" rel="noreferrer"
                        style={{flex:1,fontSize:13,color:'var(--accent)',textDecoration:'none',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                        {nomeFile(a)}
                      </a>
                      <span style={{fontSize:11,color:'var(--text-faint)',whiteSpace:'nowrap'}}>{formatDate(a.created_at)}</span>
                      <button onClick={()=>delAllegato(a.id)} style={{background:'none',border:'none',cursor:'pointer',color:'var(--c-red)',fontSize:16}}>×</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          <input ref={fileRef} type="file" multiple style={{display:'none'}}
            onChange={e=>{ if(e.target.files.length) uploadFiles(e.target.files); e.target.value=''; }} />
        </div>

        <div>
          <div className="card">
            <div className="card-header"><span className="card-title">Cliente</span></div>
            <div className="card-body">
              <div style={{fontWeight:600,fontSize:14,marginBottom:6}}>{clienteNome(dich)}</div>
              {dich.cf && <div style={{fontSize:12,color:'var(--text-muted)'}}>CF: {dich.cf}</div>}
              {dich.piva && <div style={{fontSize:12,color:'var(--text-muted)'}}>P.IVA: {dich.piva}</div>}
            </div>
          </div>
          <div className="card" style={{marginTop:14}}>
            <div className="card-header"><span className="card-title">Riepilogo allegati</span></div>
            <div className="card-body">
              {TIPI_ALLEGATO.map(t=>(
                <div key={t.key} style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'4px 0',borderBottom:'1px solid var(--border)'}}>
                  <span>{t.label}</span>
                  <span style={{fontWeight:600,color:allegatiPerTipo[t.key]?.length?'var(--c-green)':'var(--text-faint)'}}>
                    {allegatiPerTipo[t.key]?.length||0}
                  </span>
                </div>
              ))}
              <div style={{display:'flex',justifyContent:'space-between',fontSize:13,fontWeight:700,padding:'6px 0 0',marginTop:4}}>
                <span>Totale</span><span>{dich.allegati?.length||0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── LISTA DICHIARAZIONI PER TIPO ─────────────────────────────────────────────
function ListaDichiarazioni({ tipoDich, onBack, onOpen, addToast }) {
  const cat = catInfo(tipoDich);
  const [rows, setRows]     = useState([]);
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [anno, setAnno]     = useState(new Date().getFullYear()-1);
  const [filtroStato, setFiltroStato] = useState('');
  const [q, setQ]           = useState('');
  const [selected, setSelected] = useState(new Set());
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [delItem, setDelItem]   = useState(null);
  const [delMulti, setDelMulti] = useState(false);
  const [saving, setSaving]   = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showGenera, setShowGenera] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [sortKey, setSortKey] = useState('nome');
  const [sortDir, setSortDir] = useState('asc');

  useEffect(()=>{
    fetch('/api/clienti?limit=500',{headers:{Authorization:tk()}})
      .then(r=>r.json()).then(j=>{ if(j.success) setClienti(j.data?.rows||[]); });
  },[]);

  const load = useCallback(()=>{
    setLoading(true);
    apiFetch(`/api/dichiarazioni?tipo_dichiarazione=${tipoDich}&anno=${anno}`)
      .then(r=>r.json()).then(j=>{ if(j.success) setRows(j.data||[]); })
      .finally(()=>setLoading(false));
  },[tipoDich,anno]);
  useEffect(()=>{ load(); },[load]);

  const filtered = rows.filter(r=>{
    if(filtroStato && r.stato!==filtroStato) return false;
    if(q){ const txt=[clienteNome(r),r.protocollo,r.note].join(' ').toLowerCase(); if(!txt.includes(q.toLowerCase())) return false; }
    return true;
  }).sort((a,b)=>{
    let va,vb;
    if(sortKey==='nome'){ va=clienteNome(a); vb=clienteNome(b); }
    else if(sortKey==='anno'){ va=a.anno_imposta; vb=b.anno_imposta; }
    else if(sortKey==='stato'){ va=a.stato; vb=b.stato; }
    else if(sortKey==='allegati'){ va=a.n_allegati||0; vb=b.n_allegati||0; }
    else { va=''; vb=''; }
    if(va<vb) return sortDir==='asc'?-1:1;
    if(va>vb) return sortDir==='asc'?1:-1;
    return 0;
  });

  const handleSort = (k) => { if(sortKey===k) setSortDir(d=>d==='asc'?'desc':'asc'); else{setSortKey(k);setSortDir('asc');} };
  const si2 = (k) => sortKey===k?(sortDir==='asc'?'▲':'▼'):'⇅';
  const Th = ({label,k,style={}}) => (
    <div onClick={()=>handleSort(k)} style={{cursor:'pointer',userSelect:'none',...style}}>
      {label} <span style={{fontSize:9,opacity:0.5}}>{si2(k)}</span>
    </div>
  );

  const toggleSel = (id)=>setSelected(p=>{const n=new Set(p);n.has(id)?n.delete(id):n.add(id);return n;});
  const selAll = ()=>setSelected(new Set(filtered.map(r=>r.id)));
  const clrSel = ()=>setSelected(new Set());

  const handleSave = async(d)=>{
    setSaving(true);
    try{
      const data={...d,tipo_dichiarazione:tipoDich,tipo_cliente:cat.cat};
      const url=editItem?`/api/dichiarazioni/${editItem.id}`:'/api/dichiarazioni';
      const method=editItem?'PUT':'POST';
      const res=await apiFetch(url,{method,body:JSON.stringify(data)});
      const j=await res.json();
      if(!j.success) throw new Error(j.error);
      addToast(editItem?'Aggiornata':'Creata','success');
      setShowForm(false);setEditItem(null);load();
    }catch(e){addToast(e.message,'error');}
    finally{setSaving(false);}
  };

  const handleDelete=async()=>{
    try{
      await apiFetch(`/api/dichiarazioni/${delItem.id}`,{method:'DELETE'});
      addToast('Eliminata','success');setDelItem(null);load();
    }catch(e){addToast(e.message,'error');}
  };

  const handleDeleteSelected=async()=>{
    try{
      await Promise.all([...selected].map(id=>apiFetch(`/api/dichiarazioni/${id}`,{method:'DELETE'})));
      addToast(`${selected.size} eliminate`,'success');
      setSelected(new Set());setDelMulti(false);load();
    }catch(e){addToast(e.message,'error');}
  };

  const handleGenera=async()=>{
    setGenerating(true);
    try{
      const res=await apiFetch('/api/dichiarazioni/genera-da-anagrafica',{
        method:'POST',body:JSON.stringify({anno,tipo_cliente:cat.cat,tipo_dichiarazione:tipoDich})
      });
      const j=await res.json();
      if(!j.success) throw new Error(j.error);
      addToast(`${j.data.creati} create (${j.data.saltati} già presenti)`,'success');
      setShowGenera(false);load();
    }catch(e){addToast(e.message,'error');}
    finally{setGenerating(false);}
  };

  const stats={
    da_fare:rows.filter(r=>r.stato==='DA_FARE').length,
    in_lav:rows.filter(r=>r.stato==='IN_LAVORAZIONE').length,
    completate:rows.filter(r=>r.stato==='COMPLETATA').length,
    inviate:rows.filter(r=>r.stato==='INVIATA').length,
  };
  const anniFiltro=[]; for(let y=new Date().getFullYear();y>=2018;y--) anniFiltro.push(y);

  return (
    <div className="page-content">
      {/* Header */}
      <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center',marginBottom:12}}>
        <button className="btn btn-sm" onClick={onBack}>← Dichiarativi</button>
        <div style={{fontSize:16,fontWeight:700,flex:1}}>
          {cat.icon} {cat.label}
          <span style={{marginLeft:8,padding:'2px 8px',borderRadius:10,fontSize:11,fontWeight:700,background:'var(--accent)22',color:'var(--accent)'}}>{rows.length}</span>
        </div>
        {[['DA_FARE','Da fare','var(--text-faint)',stats.da_fare],
          ['IN_LAVORAZIONE','In lav.','var(--c-amber)',stats.in_lav],
          ['COMPLETATA','Compl.','var(--c-green)',stats.completate],
          ['INVIATA','Inviate','var(--accent)',stats.inviate]
        ].map(([k,l,col,n])=>(
          <button key={k} onClick={()=>setFiltroStato(s=>s===k?'':k)}
            style={{padding:'3px 10px',borderRadius:10,fontSize:11,cursor:'pointer',
              border:`1.5px solid ${filtroStato===k?col:'var(--border-strong)'}`,
              background:filtroStato===k?col:'transparent',
              color:filtroStato===k?'white':col,fontWeight:600}}>
            {l} {n}
          </button>
        ))}
      </div>

      {/* Barra filtri */}
      <div style={{display:'flex',gap:8,marginBottom:12,flexWrap:'wrap',alignItems:'center'}}>
        <select className="form-control" style={{width:'auto'}} value={anno} onChange={e=>setAnno(e.target.value)}>
          {anniFiltro.map(y=><option key={y} value={y}>{y}</option>)}
        </select>
        <div className="search-box" style={{flex:1,maxWidth:280}}>
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
          <input placeholder="Cerca…" value={q} onChange={e=>setQ(e.target.value)} />
        </div>
        <div style={{marginLeft:'auto',display:'flex',gap:6}}>
          {selected.size>0 && <button className="btn btn-sm btn-danger" onClick={()=>setDelMulti(true)}>🗑 Elimina {selected.size}</button>}
          <button className="btn btn-sm" onClick={()=>setShowImport(true)}>📥 Importa</button>
          <button className="btn btn-sm" onClick={()=>setShowGenera(true)}>⚡ Genera</button>
          <button className="btn btn-primary btn-sm" onClick={()=>setShowForm(true)}>+ Nuova</button>
        </div>
      </div>

      {/* Tabella */}
      <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius)',overflow:'hidden'}}>
        <div style={{display:'grid',gridTemplateColumns:'28px 1fr 80px 110px 70px 70px',
          gap:8,padding:'7px 14px',background:'var(--bg)',borderBottom:'2px solid var(--border)',
          fontSize:10.5,fontWeight:700,color:'var(--text-faint)',textTransform:'uppercase',letterSpacing:'0.4px'}}>
          <input type="checkbox" onChange={e=>e.target.checked?selAll():clrSel()}
            checked={selected.size>0&&selected.size===filtered.length}
            style={{accentColor:'var(--accent)',cursor:'pointer'}} />
          <Th label="Cliente" k="nome" />
          <Th label="Anno" k="anno" />
          <Th label="Stato" k="stato" />
          <Th label="Allegati" k="allegati" />
          <div>Azioni</div>
        </div>

        {loading ? <div style={{padding:32}}><LoadingSpinner /></div>
        : filtered.length===0 ? (
          <div className="empty-state" style={{padding:32}}>
            <div className="empty-state-icon">{cat.icon}</div>
            <div className="empty-state-title">Nessuna dichiarazione {cat.label} per il {anno}</div>
            <div style={{marginTop:8,fontSize:13,color:'var(--text-faint)'}}>
              Usa "⚡ Genera" per creare automaticamente o "📥 Importa" da Excel
            </div>
          </div>
        ) : filtered.map(r=>{
          const si=statoInfo(r.stato);
          return (
            <div key={r.id} style={{display:'grid',gridTemplateColumns:'28px 1fr 80px 110px 70px 70px',
              gap:8,padding:'9px 14px',borderBottom:'1px solid var(--border)',alignItems:'center',fontSize:13,
              background:selected.has(r.id)?'var(--accent-light)':'transparent'}}>
              <input type="checkbox" checked={selected.has(r.id)} onChange={()=>toggleSel(r.id)}
                style={{accentColor:'var(--accent)',cursor:'pointer'}} onClick={e=>e.stopPropagation()} />
              <div style={{fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',
                cursor:'pointer',color:'var(--accent)'}} onClick={()=>onOpen(r.id)}>
                {clienteNome(r)}
              </div>
              <div style={{fontSize:12}}>{r.anno_imposta}</div>
              <div>
                <span style={{padding:'2px 7px',borderRadius:8,fontSize:11,fontWeight:600,background:si.color+'22',color:si.color}}>
                  {si.label}
                </span>
              </div>
              <div style={{fontSize:12,textAlign:'center'}}>
                {r.n_allegati>0?<span style={{color:'var(--c-green)',fontWeight:600}}>📎 {r.n_allegati}</span>:'—'}
              </div>
              <div style={{display:'flex',gap:4}} onClick={e=>e.stopPropagation()}>
                <button className="btn btn-sm" onClick={()=>{setEditItem(r);setShowForm(true);}}>✎</button>
                <button className="btn btn-sm btn-danger" onClick={()=>setDelItem(r)}>×</button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modali */}
      {showForm && (
        <Modal title={editItem?'Modifica':'Nuova '+cat.label} onClose={()=>{setShowForm(false);setEditItem(null);}}>
          <DichiarazioneForm initial={editItem||{}} clientiList={clienti} tipoDich={tipoDich}
            onSave={handleSave} onClose={()=>{setShowForm(false);setEditItem(null);}} loading={saving} />
        </Modal>
      )}
      {showImport && (
        <Modal title={'📥 Importa '+cat.label} onClose={()=>setShowImport(false)}>
          <ImportModal tipoDich={tipoDich} onClose={()=>setShowImport(false)}
            onDone={()=>{setShowImport(false);load();}} addToast={addToast} />
        </Modal>
      )}
      {showGenera && (
        <Modal title="⚡ Genera da anagrafica" onClose={()=>setShowGenera(false)} size="sm">
          <div style={{padding:'8px 0 16px'}}>
            <p style={{fontSize:13,color:'var(--text-muted)',marginBottom:16}}>
              Creerà automaticamente una dichiarazione <strong>{cat.label}</strong> per ogni cliente {cat.cat==='PF'?'persona fisica':'società'},
              saltando quelli che hanno già la dichiarazione per l'anno selezionato.
            </p>
            <div className="form-group">
              <label className="form-label">Anno imposta</label>
              <select className="form-control" value={anno} onChange={e=>setAnno(e.target.value)}>
                {anniFiltro.map(y=><option key={y} value={y}>{y}</option>)}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn" onClick={()=>setShowGenera(false)}>Annulla</button>
            <button className="btn btn-primary" onClick={handleGenera} disabled={generating}>
              {generating?'⏳':'⚡ Genera'}
            </button>
          </div>
        </Modal>
      )}
      {delItem && <ConfirmDialog message={`Eliminare dichiarazione di ${clienteNome(delItem)}?`}
        onConfirm={handleDelete} onCancel={()=>setDelItem(null)} />}
      {delMulti && <ConfirmDialog message={`Eliminare ${selected.size} dichiarazioni selezionate?`}
        onConfirm={handleDeleteSelected} onCancel={()=>setDelMulti(false)} />}
    </div>
  );
}

// ─── ROUTER PRINCIPALE ────────────────────────────────────────────────────────
export default function Dichiarazioni({ addToast }) {
  const navigate = useNavigate();
  const { tipo, id } = useParams();

  if (id) return <DettaglioDichiarazione id={id} addToast={addToast} onBack={()=>navigate('/dichiarazioni/'+tipo)} />;
  if (tipo) return <ListaDichiarazioni tipoDich={tipo} addToast={addToast}
    onBack={()=>navigate('/dichiarazioni')}
    onOpen={(id)=>navigate('/dichiarazioni/'+tipo+'/'+id)} />;
  return <HomeDichiarazioni onSelect={(tipo)=>navigate('/dichiarazioni/'+tipo)} />;
}
